import { useContext } from "react"
import { AreaContext } from "../context/AreaContext"
import { StoragePack } from "./StoragePack";
import { Box } from "@mui/material";

export const StoragePackList = () => {
    const {area} = useContext(AreaContext);

    return(
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
            }}
        >
            {area.storagePacks?.map(sp => {
                if(sp.type !== "DEFAULT"){
                    return <StoragePack key={sp.id} id={sp.id} type={sp.type} size={sp.size} owner={sp.owner} renewalDate={sp.renewalDate} distributions={sp.distributions} />
                }
            })}
        </Box>
    )
}